import { render } from "./NumberInput.vue?vue&type=template&id=3a4240a4&scoped=true&ts=true"
import script from "./NumberInput.vue?vue&type=script&lang=ts"
export * from "./NumberInput.vue?vue&type=script&lang=ts"

import "./NumberInput.vue?vue&type=style&index=0&id=3a4240a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4240a4"]])

export default __exports__